import axios from "axios";
import * as constants from "../assets/constants";

export function clearAuthStorage() {
    localStorage.removeItem(constants.last_login_data_key)
    localStorage.removeItem(constants.USER_NAME)
    localStorage.removeItem(constants.PASSWORD)
}

function notifyUnauthorized() {
    clearAuthStorage()
    window.postMessage({ type: 'unauthorized', message: 'Сессия истекла' })
}

// Глобальный interceptor для обработки 401 ошибки во ВСЕХ axios запросах
axios.interceptors.response.use(
    (response) => {
        if (response && response.data && response.data.code === 'credentials_changed') {
            notifyUnauthorized()
        }
        return response
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            notifyUnauthorized()
        }
        return Promise.reject(error)
    }
)

export class baseApi {

    base_url = ""
    rec_sclads = []
    divisions = []

    constructor(base_url) {
        this.base_url = base_url
    }

    init = () =>{
        this.getRecSclads()
        this.getDivisions()
    }

    /**
     * Session bootstrap (`/?app=index&act=init`).
     * `user.banner` — toast when 1C exchange is stale; API sends it only if
     * `tech_banner_enabled` is on (same as the old catalog layout).
     * `user.tech_banner` + `tech_banner_enabled` — maintenance Banner on the home page.
     */
    checkSession = async () => {
        return await this.post('', {})
    }

    post = async (url, data) => {

        const body = new FormData()

        Object.keys(data).map((key) => {
            const value = data[key]
            body.append(key, value)
        })

        return await axios.post(this.base_url + url, body,
            {
                withCredentials: true
            }
        )
    }

    get = async (url) => {

       return await axios.get(this.base_url + url,
            {
                withCredentials: true
            }
        )
    }
    openProductSearch = (name) => {
        window.open('/ostatki/?search='+name,'blank_')
    }

    isOnlyScissors = (user, sclad_external_id) => {
        let showScissors = false
        if(user.meta && user.meta.my_sclads && Array.isArray(user.meta.my_sclads)) {
            const mySclad =  user.meta.my_sclads.find(el => el.id == sclad_external_id)
            if(mySclad && mySclad.scissors_sclads == '0'){
                showScissors = true
            }
        }
        return showScissors
    }
    /**
     * Проверяет, истёк ли кэш для rec_sclads
     * @returns {boolean} true если кэш истёк или отсутствует
     */
    isRecScladsCacheExpired = () => {
        const lastUpdate = localStorage.getItem(constants.rec_sclads_last_update_key);
        if (!lastUpdate) return true;
        
        const elapsed = Date.now() - parseInt(lastUpdate, 10);
        return elapsed > constants.REC_SCLADS_DIVISIONS_CACHE_TTL_MS;
    }

    /**
     * Сбрасывает кэш rec_sclads (нужно при logout / новом логине)
     */
    clearRecScladsCache = () => {
        localStorage.removeItem(constants.rec_sclads_cache_key);
        localStorage.removeItem(constants.rec_sclads_last_update_key);
        this.rec_sclads = [];
    }

    clearAuthStorage = clearAuthStorage

    getRecSclads = (onLoad, force = false) => {
        // Проверяем кэш перед запросом
        if (!force && !this.isRecScladsCacheExpired()) {
            const cached = localStorage.getItem(constants.rec_sclads_cache_key);
            if (cached) {
                try {
                    this.rec_sclads = JSON.parse(cached);
                    window.postMessage('getRecScladsLoaded');
                    if(typeof onLoad === 'function'){
                        onLoad(this.rec_sclads);
                    }
                    console.log('⏳ rec_sclads: кэш актуален, используем сохранённые данные');
                    return;
                } catch (e) {
                    console.error('Ошибка парсинга rec_sclads из кэша:', e);
                }
            }
        }

        let sAjaxSource = '/?app=cart&act=getRecSclads'

        axios.get(this.base_url + sAjaxSource,
            {
                withCredentials: true
            }
        ).then((response) => {

            this.rec_sclads = response.data.results;
            
            // Сохраняем в кэш
            localStorage.setItem(constants.rec_sclads_cache_key, JSON.stringify(this.rec_sclads));
            localStorage.setItem(constants.rec_sclads_last_update_key, Date.now().toString());
            console.log('✅ rec_sclads: данные загружены с сервера и сохранены в кэш');
            
            window.postMessage('getRecScladsLoaded')
            if(typeof onLoad === 'function'){
                onLoad(this.rec_sclads)
            }

        })

    };
    /**
     * Проверяет, истёк ли кэш для divisions
     * @returns {boolean} true если кэш истёк или отсутствует
     */
    isDivisionsCacheExpired = () => {
        const lastUpdate = localStorage.getItem(constants.divisions_last_update_key);
        if (!lastUpdate) return true;
        
        const elapsed = Date.now() - parseInt(lastUpdate, 10);
        return elapsed > constants.REC_SCLADS_DIVISIONS_CACHE_TTL_MS;
    }

    getDivisions = (onLoad, search = '', force = false) => {
        // Кэшируем только если search пустой, для поиска всегда делаем запрос
        if (!search && !force && !this.isDivisionsCacheExpired()) {
            const cached = localStorage.getItem(constants.divisions_cache_key);
            if (cached) {
                try {
                    this.divisions = JSON.parse(cached);
                    window.postMessage('getRecScladsLoaded');
                    if(typeof onLoad === 'function'){
                        onLoad(this.divisions);
                    }
                    console.log('⏳ divisions: кэш актуален, используем сохранённые данные');
                    return;
                } catch (e) {
                    console.error('Ошибка парсинга divisions из кэша:', e);
                }
            }
        }

        let sAjaxSource = '/?&act=getDivisions&term='+search

        console.log(`🔍 getDivisions: запрос к серверу с поиском "${search}"`);

        axios.get(this.base_url + sAjaxSource,
            {
                withCredentials: true
            }
        ).then((response) => {

            this.divisions = response.data.results;
            
            // Сохраняем в кэш только если search пустой
            if (!search) {
                localStorage.setItem(constants.divisions_cache_key, JSON.stringify(this.divisions));
                localStorage.setItem(constants.divisions_last_update_key, Date.now().toString());
                console.log('✅ divisions: данные загружены с сервера и сохранены в кэш');
            } else {
                console.log(`✅ divisions: результаты поиска "${search}" получены, найдено: ${this.divisions?.length || 0}`);
            }
            
            window.postMessage('getRecScladsLoaded')
            if(typeof onLoad === 'function'){
                onLoad(this.divisions)
            }

        }).catch((error) => {
            console.error('❌ Ошибка при загрузке divisions:', error);
            this.divisions = [];
            window.postMessage('getRecScladsLoaded');
            if(typeof onLoad === 'function'){
                onLoad([]);
            }
        })

    };

}

export default new baseApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod)
